import React, { createContext, useState } from "react";

const GeneralContext = createContext({})

export const GeneralProvider = ({children}) => {
    const [user, setUser] = useState(localStorage.getItem('clerkUser') ? localStorage.getItem('clerkUser') : "");
    const [video, setVideo] = useState("");
    const [origin, setOrigin] = useState("");

    return <GeneralContext.Provider
        value={{
            user,
            setUser,
            video,
            setVideo,
            origin, setOrigin
        }}
    >
        {children}

    </GeneralContext.Provider>


}

export default GeneralContext;